<template>

  <div class="table-container" >
  <!-- {{styleDataSendTomodal.costsheet_details}} -->
   <form @submit.prevent="sendCosheetData('form')" data-vv-scope="form">
        <table class="costlisting scrolldown" >
            <thead>
                <tr>
            
                    <th class="fixed-column">BRAND: {{styleDataSendTomodal["BRAND TITLE"]}}</th>
                    <th v-for="(pack, index) in packs" :key="index">{{ pack.label }}</th>
                </tr>
            </thead>
           <tbody>
           <tr>
                  <td class="fixed-column"><b>SUB CATEGORY NAME</b></td>
                  <td v-for="pack in packs" class="wrapword">
                    <p>{{styleDataSendTomodal["SUB CATEGORY NAME"]}}</p>
                  </td>
                </tr>
                <tr>
                  <td class="fixed-column"><b>PRODUCT TYPE</b></td>
                  <td v-for="pack in packs" class="wrapword">
                    <p>{{styleDataSendTomodal["PRODUCT TYPE"]}}</p>
                  </td>
                </tr>
                <tr>
                  <td class="fixed-column"><b>STYLE</b></td>
                  <td v-for="pack in packs" class="wrapword">
                    <p>{{ styleDataSendTomodal['STYLE'] }}</p>
                  </td>
                </tr>
                <tr>
                  <td class="fixed-column"><b>COLOUR</b></td>
                  <td v-for="pack in packs" class="wrapword">
                    <p v-for="data in colordata">{{ data }}</p>
                  </td>
                </tr>
                 <tr>
                  <td class="fixed-column"><b>SSN</b></td>
                  <td v-for="pack in packs" class="wrapword">
                   <p>{{styleDataSendTomodal["SSN"]}}</p>
                  </td>
                </tr>
                 <tr>
                  <td class="fixed-column"><b>SIZE</b></td>
                  <td v-for="pack in packs" class="wrapword">
                   <p v-for="finalsize in sizeDetails">{{finalsize}}</p>
                  </td>
                </tr>
                <!-- <tr v-for="(item, index) in styleDataSendTomodal.tabledata" :key="index">
          <td>{{ item }}</td>
        </tr> -->
                 <!-- Bind tableData and packsData -->
                    <tr v-for="(row, rowIndex) in styleDataSendTomodal.tabledata" :key="rowIndex">
                        <td class="fixed-column">{{ row }}</td>
                        <td v-for="(pack, colIndex) in styleDataSendTomodal.packsData" :key="colIndex" class="wrapword">
                        
                        <input
                          v-if="row.includes('Fabric1 Quality')"
                          type="text"
                          class="form-control"
                          v-model="pack.values[rowIndex]" disabled
                        />

                        <input
                           v-else-if="row.includes('Fabric2 Quality')"
                          type="text"
                          class="form-control"
                          v-model="pack.values[rowIndex]" disabled
                        />

                        <input
                          v-else-if="row.includes('Fabric3 Quality') || row.includes('Fabric4 Quality') || row.includes('Fabric1 Weight/Construction') || row.includes('Fabric2 Weight/Construction') || row.includes('Fabric3 Weight/Construction') || row.includes('Fabric4 Weight/Construction')"
                          type="text"
                          class="form-control"
                          v-model="pack.values[rowIndex]"
                        />

                        <input
                        v-else
                            class="form-control"
                            :class="{ 'positive-number': isNegative(pack.values[rowIndex]) }"
                            type="number"
                            :step="0.01"
                            :disabled="rowIndex == 4 || rowIndex == 9 || rowIndex == 14 || rowIndex == 19 || rowIndex == 20 || rowIndex == 25 || rowIndex == 33 || rowIndex == 42 || rowIndex == 43 || rowIndex == 45 || rowIndex == 46 || rowIndex == 49 "
                            v-model="pack.values[rowIndex]"
                            :placeholder="pack.placeholder"
                            @input="calculateTotal(row, rowIndex, colIndex)"
                            min="0"
                          />
                        <div class="error-message" v-if="isNegative(pack.values[rowIndex])">
                            Please enter a positive number.
                        </div>
                        </td>
                    </tr>

                    <tr>
                      <td class="fixed-column"><b>AVG TARGET</b></td>
                      <td>
                          <input class="avg form-control" type="number" v-model="styleDataSendTomodal.average" readonly />
                        </td>
                    </tr>

                    <tr>
                      <td class="fixed-column"><b>Final Cost</b></td>
                      <td>
                          <input class="avg form-control" type="number" v-model="styleDataSendTomodal.finalcost" readonly />
                        </td>
                    </tr>

                <div v-if="formstatus == 'edit'">
                    <button type='submit' class="btn btn-success submit_btn invoice-save-bottom mt-2"  style="margin-right: 10px;">
                        <i class="fa fa-save"></i>
                        Submit Quote
                    </button>
                    <button @click="sendDataToParent" class="btn btn-danger mt-2" type="button">Close</button>
                </div>
                
           </tbody>
        </table>
      </form>
    </div>

</template>
<!-- <template>
<p v-for="(row, rowIndex) in styleDataSendTomodal.tableData" :key="rowIndex">
{{row}}</p>
<tr v-for="(item, index) in styleDataSendTomodal.tabledata" :key="index">
          <td>{{ item }}</td>
        </tr>
<p v-for="data in styleDataSendTomodal.tabledata">{{styleDataSendTomodal.tabledata}}</p>

</template> -->


<script>
import CONSTANTS from "@/utils/constants";
import Utils from "@/utils";
import Vue from 'vue'
import auth from "@/utils/auth";
import VeeValidate from 'vee-validate'
const axios = require('axios');
export default {
  props: ['styleDataSendTomodal', 'showcomponetModel', 'formstatus','selected_vendor_id', 'selectedquote_id', 'selected_style_id'],
   data: function () {
    return {
     
      packs: [
        { label: "Pack 1" },
        { label: "Pack 2" },
        { label: "Pack 3" },
        { label: "Pack 4" },
        { label: "Pack 5" },
        { label: "Pack 6" },
        { label: "Pack 7" },
        { label: "Pack 8" },
        { label: "Pack 9" },
        { label: "Pack 10" },
      ],
      tableData: [
        { label: "Fabric1 Quality", values: new Array(10).fill("") },
        { label: "Fabric1 Weight/Construction", values: new Array(10).fill("") },
        { label: "Fabric1 Price", values: new Array(10).fill("") },
        { label: "Consumption", values: new Array(10).fill("") },
        { label: "Fabric1 Cost / pc", values: new Array(10).fill("") },
        { label: "Fabric2 Quality", values: new Array(10).fill("") },
        { label: "Fabric2 Weight/Construction", values: new Array(10).fill("") },
        { label: "Fabric2 Price", values: new Array(10).fill("") },
        { label: "Consumption", values: new Array(10).fill("") },
        { label: "Fabric2 Cost / pc", values: new Array(10).fill("") },
        { label: "Fabric3 Quality", values: new Array(10).fill("") },
        { label: "Fabric3 Weight/Construction", values: new Array(10).fill("") },
        { label: "Fabric3 Price", values: new Array(10).fill("") },
        { label: "Consumption", values: new Array(10).fill("") },
        { label: "Fabric3 Cost / pc", values: new Array(10).fill("") },
        { label: "Fabric4 Quality", values: new Array(10).fill("") },
        { label: "Fabric4 Weight/Construction", values: new Array(10).fill("") },
        { label: "Fabric4 Price", values: new Array(10).fill("") },
        { label: "Consumption", values: new Array(10).fill("") },
        { label: "Fabric4 Cost / pc", values: new Array(10).fill("0"), disabled: true  },
        { label: "Total Fabric Cost (A)", values: new Array(10).fill("0"),  disabled: true  },
        { label: "CMPT", values: new Array(10).fill("") },
        { label: "PRINT", values: new Array(10).fill("") },
        { label: "EMB", values: new Array(10).fill("") },
        { label: "WASH", values: new Array(10).fill("") },
        { label: "Total Embellishment Cost (B)", values: new Array(10).fill("0"),disabled: true },
        { label: "MAIN LBL", values: new Array(10).fill("") },
        { label: "CARE LBL", values: new Array(10).fill("") },
        { label: "Mobelon Tape", values: new Array(10).fill("") },
        { label: "DRAW CORD/TAPES/LACE", values: new Array(10).fill("") },
        { label: "ELASTIC", values: new Array(10).fill("") },
        { label: "BRANDING LBL", values: new Array(10).fill("") },
        { label: "ZIPPER", values: new Array(10).fill("") },
        { label: "Total Stitching Axx Cost (C)", values: new Array(10).fill("0"), disabled: true },
        { label: "POLYBAG", values: new Array(10).fill("") },
        { label: "MAIN TAG+STRING", values: new Array(10).fill("") },
        { label: "BIO TAG", values: new Array(10).fill("") },
        { label: "SPECIAL TAG", values: new Array(10).fill("") },
        { label: "BARCODE", values: new Array(10).fill("") },
        { label: "SIZE STICKER", values: new Array(10).fill("") },
        { label: "CARTON", values: new Array(10).fill("") },
        { label: "CARTON TAPE", values: new Array(10).fill("") },
        { label: "Total Packing Axx Cost (D)", values: new Array(10).fill("0"), disabled: true},
        { label: "SUBTOTAL", values: new Array(10).fill("0"), disabled: true },
        { label: "Margin (value in %)", values: new Array(10).fill("") },
        { label: "Margin Value", values: new Array(10).fill("0"), disabled: true },
        { label: "Final Cost", values: new Array(10).fill(""), disabled: true },
        { label: "GPT", values: new Array(10).fill("") },
        { label: "Transportation", values: new Array(10).fill("") },
        { label: "TOTAL", values: new Array(10).fill("0"), disabled: true },
        
      ],
    
      totalA : 0,
      totalB : 0,
      totalC: 0,
      totalD: 0,
      totalE: 0,
      totalF: 0,
      totalG: 0,
      totalH : 0,
      totalJ: 0,
      totalK : 0,
      totalL:0,
       averageTarget: 0,
       tablelabel:'',
       validatepostivenumber:'',
       costsheet_details : {},
       userInfo: [],
       refarray :[],
       colordata:[],
       sizeDetails:[],
       errorCounter:0

    };
  },

created: function(){
  // console.log("styleDataSendTomodal.tabledata",this.styleDataSendTomodal.tabledata)
  console.log("asffffffffffff",this.styleDataSendTomodal)

  this.styleDataSendTomodal = this.styleDataSendTomodal
  // console.log("gchvjbknm", this.styleDataSendTomodal['COLOUR'].join())
  this.colordata =   this.styleDataSendTomodal['COLOUR'].split(',')

  console.log("hgvjhbknklm", this.styleDataSendTomodal.SIZE)

  let size = JSON.parse(this.styleDataSendTomodal.SIZE)
  
  this.sizeDetails = (size[0].unit);

},


methods: {
    calculateTotal(row, colIndex, rowIndex) {
      
      if(colIndex<0){
        this.errorCounter+=1
      }else{
        this.errorCounter-=1
        
      }
      console.log("row, colIndex, rowIndex", row, colIndex, rowIndex)
      // console.log("in")
      // const rowData = this.styleDataSendTomodal.tabledata[rowIndex];
      //  this.styleDataSendTomodal.packsData[rowIndex].values[2] = parseFloat(this.styleDataSendTomodal.packsData[rowIndex].values[0]) + parseFloat(this.styleDataSendTomodal.packsData[rowIndex].values[1]);

    for (let i = 2; i <= 3; i++) {
      const value = parseFloat(this.styleDataSendTomodal.packsData[rowIndex].values[i]);
      if (!isNaN(value)) {
        this.totalJ = parseFloat(this.styleDataSendTomodal.packsData[rowIndex].values[2] ? this.styleDataSendTomodal.packsData[rowIndex].values[2] :0) * parseFloat(this.styleDataSendTomodal.packsData[rowIndex].values[3] ? this.styleDataSendTomodal.packsData[rowIndex].values[3] :0);
        }
      }
      this.styleDataSendTomodal.packsData[rowIndex].values[4] = !isNaN(this.totalJ) ? this.totalJ.toFixed(2) : '';


      for (let i = 7; i <= 8; i++) {
      const value = parseFloat(this.styleDataSendTomodal.packsData[rowIndex].values[i]);
      if (!isNaN(value)) {
        this.totalK = parseFloat(this.styleDataSendTomodal.packsData[rowIndex].values[7] ? this.styleDataSendTomodal.packsData[rowIndex].values[7] :0) * parseFloat(this.styleDataSendTomodal.packsData[rowIndex].values[8] ? this.styleDataSendTomodal.packsData[rowIndex].values[8] :0);
        }
      }
      this.styleDataSendTomodal.packsData[rowIndex].values[9] = !isNaN(this.totalK) ? this.totalK.toFixed(2) : '';

      for (let i = 12; i <= 13; i++) {
      const value = parseFloat(this.styleDataSendTomodal.packsData[rowIndex].values[i]);
      if (!isNaN(value)) {
        this.totalL = parseFloat(this.styleDataSendTomodal.packsData[rowIndex].values[12] ? this.styleDataSendTomodal.packsData[rowIndex].values[12] :0) * parseFloat(this.styleDataSendTomodal.packsData[rowIndex].values[13] ? this.styleDataSendTomodal.packsData[rowIndex].values[13] :0);
        }
      }
      this.styleDataSendTomodal.packsData[rowIndex].values[14] = !isNaN(this.totalL) ? this.totalL.toFixed(2) : '';


      for (let i = 17; i <= 18; i++) {
      const value = parseFloat(this.styleDataSendTomodal.packsData[rowIndex].values[i]);
      if (!isNaN(value)) {
        this.totalA = parseFloat(this.styleDataSendTomodal.packsData[rowIndex].values[17] ? this.styleDataSendTomodal.packsData[rowIndex].values[17] :0) * parseFloat(this.styleDataSendTomodal.packsData[rowIndex].values[18] ? this.styleDataSendTomodal.packsData[rowIndex].values[18] :0);
        }
      }
      this.styleDataSendTomodal.packsData[rowIndex].values[19] = !isNaN(this.totalA) ? this.totalA.toFixed(2) : '';

      for (let j = 0; j< 19; j++) {
      const value = parseFloat(this.styleDataSendTomodal.packsData[rowIndex].values[j]);
      if (!isNaN(value)) {
        this.totalB = parseFloat(this.styleDataSendTomodal.packsData[rowIndex].values[4] ? this.styleDataSendTomodal.packsData[rowIndex].values[4] :0) + parseFloat(this.styleDataSendTomodal.packsData[rowIndex].values[9] ? this.styleDataSendTomodal.packsData[rowIndex].values[9] :0) + parseFloat(this.styleDataSendTomodal.packsData[rowIndex].values[14] ? this.styleDataSendTomodal.packsData[rowIndex].values[14] :0) + parseFloat(this.styleDataSendTomodal.packsData[rowIndex].values[19] ? this.styleDataSendTomodal.packsData[rowIndex].values[19] :0);
        }
      }
      this.styleDataSendTomodal.packsData[rowIndex].values[20] = !isNaN(this.totalB) ? this.totalB.toFixed(2) : '';

      for (let k = 21; k < 24; k++) {
        const value = parseFloat(this.styleDataSendTomodal.packsData[rowIndex].values[k]);
            if (!isNaN(value)) {
              this.totalC = parseFloat(this.styleDataSendTomodal.packsData[rowIndex].values[21] ? this.styleDataSendTomodal.packsData[rowIndex].values[21] :0) + parseFloat(this.styleDataSendTomodal.packsData[rowIndex].values[22] ? this.styleDataSendTomodal.packsData[rowIndex].values[22] :0) + parseFloat(this.styleDataSendTomodal.packsData[rowIndex].values[23] ? this.styleDataSendTomodal.packsData[rowIndex].values[23] :0) + parseFloat(this.styleDataSendTomodal.packsData[rowIndex].values[24] ? this.styleDataSendTomodal.packsData[rowIndex].values[24] :0);
            }

      }
      this.styleDataSendTomodal.packsData[rowIndex].values[25]  = !isNaN(this.totalC ) ? this.totalC .toFixed(2) : '';

      for (let l = 26; l < 32; l++) {
        const value = parseFloat(this.styleDataSendTomodal.packsData[rowIndex].values[l]);
            if (!isNaN(value)) {
              this.totalD = parseFloat(this.styleDataSendTomodal.packsData[rowIndex].values[26] ? this.styleDataSendTomodal.packsData[rowIndex].values[26] :0) + parseFloat(this.styleDataSendTomodal.packsData[rowIndex].values[27] ? this.styleDataSendTomodal.packsData[rowIndex].values[27] :0) + parseFloat(this.styleDataSendTomodal.packsData[rowIndex].values[28] ? this.styleDataSendTomodal.packsData[rowIndex].values[28] :0) + parseFloat(this.styleDataSendTomodal.packsData[rowIndex].values[29] ? this.styleDataSendTomodal.packsData[rowIndex].values[29] :0) + parseFloat(this.styleDataSendTomodal.packsData[rowIndex].values[30] ? this.styleDataSendTomodal.packsData[rowIndex].values[30] :0) 
              + parseFloat(this.styleDataSendTomodal.packsData[rowIndex].values[31] ? this.styleDataSendTomodal.packsData[rowIndex].values[31] :0) + parseFloat(this.styleDataSendTomodal.packsData[rowIndex].values[32] ? this.styleDataSendTomodal.packsData[rowIndex].values[32] :0);
              
            }

      }
      this.styleDataSendTomodal.packsData[rowIndex].values[33] = !isNaN(this.totalD) ? this.totalD.toFixed(2) : '';


      for (let m = 34; m < 41; m++) {
        const value = parseFloat(this.styleDataSendTomodal.packsData[rowIndex].values[m]);
            if (!isNaN(value)) {
              this.totalE = parseFloat(this.styleDataSendTomodal.packsData[rowIndex].values[34] ? this.styleDataSendTomodal.packsData[rowIndex].values[34] :0)
               + parseFloat(this.styleDataSendTomodal.packsData[rowIndex].values[35] ? this.styleDataSendTomodal.packsData[rowIndex].values[35] :0) + parseFloat(this.styleDataSendTomodal.packsData[rowIndex].values[36] ? this.styleDataSendTomodal.packsData[rowIndex].values[36] :0) + parseFloat(this.styleDataSendTomodal.packsData[rowIndex].values[37] ? this.styleDataSendTomodal.packsData[rowIndex].values[37] :0) + parseFloat(this.styleDataSendTomodal.packsData[rowIndex].values[38] ? this.styleDataSendTomodal.packsData[rowIndex].values[38] :0) 
              + parseFloat(this.styleDataSendTomodal.packsData[rowIndex].values[39] ? this.styleDataSendTomodal.packsData[rowIndex].values[39] :0) + parseFloat(this.styleDataSendTomodal.packsData[rowIndex].values[40] ? this.styleDataSendTomodal.packsData[rowIndex].values[40] :0) + parseFloat(this.styleDataSendTomodal.packsData[rowIndex].values[41] ? this.styleDataSendTomodal.packsData[rowIndex].values[41] :0);
              
            }

      }
      this.styleDataSendTomodal.packsData[rowIndex].values[42] = !isNaN(this.totalE) ? this.totalE.toFixed(2) : '';

      if(this.totalB || this.totalC || this.totalD || this.totalE)
      {
        this.totalF =  this.totalB + this.totalC + this.totalD + this.totalE
      }
      this.styleDataSendTomodal.packsData[rowIndex].values[43] = !isNaN(this.totalF) ? this.totalF.toFixed(2) : '';


       let totalI = 0;
      if(this.totalF || this.styleDataSendTomodal.packsData[rowIndex].values[44]){
        totalI = (parseFloat(this.styleDataSendTomodal.packsData[rowIndex].values[44]) * parseFloat(this.styleDataSendTomodal.packsData[rowIndex].values[43])) / 100
      }
      this.styleDataSendTomodal.packsData[rowIndex].values[45] = !isNaN(totalI) ? totalI.toFixed(2) : '';

      
      if(this.totalF ||  this.styleDataSendTomodal.packsData[rowIndex].values[45]){
        this.totalG = this.totalF + parseFloat( this.styleDataSendTomodal.packsData[rowIndex].values[45])
      }
      this.styleDataSendTomodal.packsData[rowIndex].values[46] = !isNaN(this.totalG) ? this.totalG.toFixed(2) : '';

      if(this.totalG || this.styleDataSendTomodal.packsData[rowIndex].values[47] || this.styleDataSendTomodal.packsData[rowIndex].values[48])
      {
        this.totalH = this.totalG + parseFloat(this.styleDataSendTomodal.packsData[rowIndex].values[47]) + parseFloat(this.styleDataSendTomodal.packsData[rowIndex].values[48])
      }
      this.styleDataSendTomodal.packsData[rowIndex].values[49] = !isNaN(this.totalH) ? this.totalH.toFixed(2) : '';

      // console.log(this.styleDataSendTomodal.packsData[rowIndex] )


      // this.calculateAverageTarget();
      this.testloop()
      // this.loopThroughTargetValues(this.totalH, rowIndex);
    },
    handleInputChange(row, colIndex) {
      this.calculateTotal(row, colIndex);
    },

    calculateAverageTarget() {

      let a = rowIndex
    
      for (let i = 0; i <= 9; i++) {
          if(a == i){
               this.total = this.totalH ;
          }

            console.log("this.total",this.total)
          
      }
    // console.log(this.totalH)
    // let totalTarget = 0;
    // const startColIndex = 0;  // Adjust this index based on your actual data structure.
    // const endColIndex = 9;    // Adjust this index based on your actual data structure.

    // for (let colIndex = startColIndex; colIndex <= endColIndex; colIndex++) {
    //   const value = parseFloat(this.tableData[49].values[colIndex]);
    //   if (!isNaN(value)) {
    //     this.total = this.totalH ;
    //   }

      //  console.log(this.tableData[49].length)
    // }
    // console.log(this.totalH)
    // console.log(this.total)
    // console.log((this.totalH + this.total))
   

    // Calculate the average
    // this.averageTarget = this.totalH / (endColIndex - startColIndex + 1);
  },

  testloop(){

     const targetValues1 = [];

    for (let colIndex = 0; colIndex < this.packs.length; colIndex++) {
      const value = parseFloat(this.styleDataSendTomodal.packsData[colIndex].values[49]);
      if (!isNaN(value)) {
        targetValues1.push(value);
      }else{
        this.styleDataSendTomodal.average = '';
        this.styleDataSendTomodal.finalcost ='';
      }
    }
     console.log("array",targetValues1)
     this.averageOfNonZeroElements(targetValues1);
  },

  loopThroughTargetValues(value, rowIndex) {
    
    console.log("this.refarray",this.refarray)
     let targetValues = [...this.refarray];
     targetValues.splice(rowIndex,1, value);
      console.log("targetValues",targetValues)
      this.refarray = targetValues
      // console.log(this.refarray )
     
    this.averageOfNonZeroElements(targetValues);

  },

  averageOfNonZeroElements(targetValues) {
  // Filter out the zeros from the array
  const nonZeroElements = targetValues.filter(element => element !== 0);
  // Check if there are non-zero elements in the array
  if (nonZeroElements.length === 0) {
    return 0; // If there are no non-zero elements, return 0
  }
  // Calculate the sum of non-zero elements
  const sum = nonZeroElements.reduce((acc, element) => acc + element, 0);
  // Calculate the average by dividing the sum by the number of non-zero elements
  const average = sum / nonZeroElements.length;
  // console.log(average,"average")
  this.average = average;
  this.styleDataSendTomodal.average = this.average.toFixed(2)
  console.log("this.average",this.styleDataSendTomodal.average )
  this.styleDataSendTomodal.finalcost = sum.toFixed(2)
  console.log(this.styleDataSendTomodal.finalcost,"this.styleDataSendTomodal.finalcost")

},


  isNegative(value) {
    // console.log(value)
        return value < 0;
        this.validatepostivenumber = value;
      },

  closeCostSheetModal(){
    this.showcomponetModel = false;
  },

   sendCosheetData(scope){
    document.getElementById("overlay").style.display = "block";
     this.$validator.validateAll(scope).then((result) => {
      var userData = localStorage.getItem('userData');
      this.userInfo = JSON.parse(userData)
      // console.log("CCCCCCCC",this.userInfo)
      this.costsheet_details = {

         "BRAND TITLE" : this.styleDataSendTomodal["BRAND TITLE"],
          "SUB CATEGORY NAME": this.styleDataSendTomodal["SUB CATEGORY NAME"],
          "PRODUCT TYPE" : this.styleDataSendTomodal["PRODUCT TYPE"],
          "STYLE" : this.styleDataSendTomodal['STYLE'],
          "COLOUR" : this.styleDataSendTomodal['COLOUR'],
          "SSN" : this.styleDataSendTomodal["SSN"],
          "SIZE" : this.styleDataSendTomodal["SIZE"],
          
          packsData: this.styleDataSendTomodal.packsData.map((pack) => ({
            label: pack.label,
            values: pack.values,
            })),
          tabledata : this.styleDataSendTomodal.tabledata.map((row) => row),
          "average" : this.styleDataSendTomodal.average ? this.styleDataSendTomodal.average : 0,
          "finalcost" : this.styleDataSendTomodal.finalcost ? this.styleDataSendTomodal.finalcost : 0,

      }

      console.log("ddddddthis.costsheet_detailsddddddd", this.costsheet_details)
      if(this.errorCounter != 0){
        if (result) {
        const payload = {

            costsheet_details: JSON.stringify(this.costsheet_details),
            Vendorid: this.selected_vendor_id,
            quote_id: this.selectedquote_id,
            styleid:this.selected_style_id,
            Total: this.styleDataSendTomodal.finalcost,
            updated_by: this.userInfo[0].email_id,
         
          };
          // this.tableData = []
      
          console.log(payload)

           axios.post(`${CONSTANTS.API_URL}/submitquotationdetails`,payload)
            .then(response => {
              this.result = response.data

              if (this.result.returnmsg === 'Successful') {
                document.getElementById("overlay").style.display = "none";
                  
                // alert("Quotation Details saved Successfully. ");
                this.$fire({
                    text:"Quotation Details Saved Successfully.",
                    type: "success",
                    timer: 900000
                  }).then(() => {
                    // This function will be called when the user clicks "OK" on the notification
                    this.handleNotificationClick();
                  });

              }
            })
      }
      }
      
      
      
     })
      // Prepare the payload
      //  for (let j= 0; i < this.tableData.length; i++) {
      //     this.tablelabel = this.tableData[i].label;
      //     //  console.log(this.tablelabel)
          
      //   }

    },

    handleNotificationClick() {
  
    this.showcomponetModel = false;
      const data = this.showcomponetModel
      // Emit a custom event with the data
      this.$emit('childDataEvent', data);
   
  },

    sendDataToParent() {
      this.showcomponetModel = false;
      const data = this.showcomponetModel
      // Emit a custom event with the data
      this.$emit('childDataEvent', data);
    },
   
  },

}

</script>

 <style>

          
    .table-container {
        padding-bottom:10px;
        width: 100%; /* Set the width of the container */
        overflow-x: scroll; /* Enable horizontal scrolling */
    }

    table {
        border-collapse: collapse;
        width: 100%;
    }

    th, td {
        border: 1px solid #ddd;
        padding-right: 100px;
        padding-top:05px;
        margin:10%;
        text-align: left;
    }

    th {
        background-color: #f2f2f2;  
        white-space: nowrap; 
    }

    .wrapword {
         white-space: nowrap; 
         padding:5px;
    }

    /* Style for the fixed column */
    .fixed-column {
        position: sticky;
        left: 0;
        padding-right: 100px;
        white-space: nowrap; 
        background-color: #fff;
        
        z-index: 1; /* Ensure the fixed column is above the scrollable column */
    }
    .costlisting tr{
        background: none !important;
    }
    .avg {
    border: 1px solid #E4E5E6;
    margin: 0px;
    padding: 9px;
    width: 2460%;
  }
  .positive-number {
  border-color: red; /* You can style it differently for negative numbers */
  color: red;
}
.error-message {
  color: red;
  font-size: 12px;
}
</style>

